import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * @description Hook that handle keydown event on search input
 */
export function useOnSearchKeyDown() {
  const [handler, setHandler] = useState(null);

  const ref = useRef(null);

  // Function that adds event listeners
  const handleOnSearchKeyDown = useCallback(() => {
    document.addEventListener('keydown', handler);

    return () => {
      document.removeEventListener('keydown', handler);
    };
  }, [handler]);

  // Add event listeners
  useEffect(() => handleOnSearchKeyDown(), [handleOnSearchKeyDown]);

  return { ref, setHandler };
}
